import React, { Component } from "react";
import "react-table/react-table.css";
import "../../tables/reactTable.css";
import ReactTableComponent from "../../tables/ReactTable";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { getContactImageUrl } from "../../../config";
import { getContactImageUrl2 } from "../../../config";
import FiberManualRecordIcon from "@material-ui/icons/Grade";
// import FiberManualRecordIcon from "@material-ui/icons/LockOpen";
import {
  campaignContactsTabList,
  campaignContactsTabSelectList,
  campaignContactsExport,
  campaignContactsExport2,
  campaignFreeContacts,
  campaignDetails
} from "../../../Queries";

import SearchIcon from "../../assets/search.png";
import { TextField, Button, IconButton } from "@material-ui/core";
import { Checkbox } from "pretty-checkbox-react";
import "../CampaignTables.css";
import "../CampaignTabs.css";
import "./CampaignContactsTab.css";
import ExportTo from "./ExportToExcel";
import ConvertTo from "./ConvertTo";
import { contacts, Profileid, plannedDate } from "../campaignQueries";
import { fetchMethod } from "../../../FetchMethod";
import ContactDetails from "./ContactDetails.js";
import { Drawer } from "@material-ui/core";
//import Photo from "../../assets/photo.png";
import swal from "sweetalert";
import { RemoveToContactUpdate, MoveToContact } from "../../../config";
const moment = require("moment");

class CampaignContactsTab extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      search: "",
      loading: false,
      limit: 0,
      offset: 0,
      searchFlag: false,
      clickToSearch: false,
      campaignContacts: [],
      campaignContactsTableList: [],
      totalCount: 0,
      totalFreeCount: 0,
      totalOpenCount: 0,
      openCampaign: 0,
      totalOpenUsedCount: 0,
      selectedDate: new Date(),
      fileName: "Contacts",
      Currentstage: [],
      invitationSent: [],
      anchorEl: null,
      show: "",
      openDetails: false,
      columnFilter: "",
      shortfilter: false,
      getData: [],
      getCampaignId: null,
      getCampaignId2: null,
      getCustomer: [],
      contactStatus: null,
      campaignStatus: null,
      contactId: null,
      Row: "",
      ContactDetailsWorkflow: [],
      ContactDetailsMessages: [],
      campStatus: ["All", "Live", "Pause", "Completed"],
      defaultCampStatus: "All",
      contStatus: ["All", "Suspect", "Prospect", "Opportunity"],
      defaultContStatus: "All",
      selected: {},
      selectAll: 0,
      selectedArray: [],
      campaignContactAllSelectedList: [],
      profileid: undefined,
      salesforcetoken: null,
      hubspottoken: null,
      isSearching: false,
      campaignContactsExportData: [],
      clientY: null,
      clientX: null
    };
  }
  componentDidMount() {
    this.fetchDetails(this.props.campaignId);
    this.FreeData();
    this.OpenData();
    this.OpenUsedData();
    this.ExportData();
    this.setState({ show: false }, () =>
      this.props.detailEdit(this.state.show)
    );
    this.Profile();
  }

  fetchDetails = campaignId => {
    fetchMethod(campaignDetails(campaignId))
      .then(response => {
        return response.json();
      })
      .then(responseAsJson => {
        this.setState(
          {
            loading: false,
            show: true
          },
          () => this.props.detailEdit(this.state.show)
        );
        this.setDetails(responseAsJson);
      })
      .catch(e => {
        console.log(e);
        this.setState({ loading: true });
      });
  };

  setDetails = response => {
    this.setState(
      {
        name: response.data.Campaigns.name,
        status: response.data.Campaigns.status,
        openCampaign: response.data.Campaigns.opencontact
      },
      () => {

        this.props.name(this.state.name);
      }
    );
  };

  // ExportData = () => {
  //   const filter = this.filter();
  //   fetchMethod(campaignContactsExport, filter)
  //     .then(res => res.json())
  //     .then(res => {
  //       this.setState({
  //         campaignContactsExportData: res.data.allContacts.Contacts
  //       });
  //     });
  // };
  ExportData = () => {

    var countactCount = this.state.totalTabDataCount;
    if (countactCount < 2500) {
      var exportQuery = campaignContactsExport;
    } else {
      var exportQuery = campaignContactsExport2;
    }

    const filter = this.filter();
    fetchMethod(exportQuery, filter)
      .then(res => res.json())
      .then(res => {
        this.setState({
          campaignContactsExportData: res.data.allContacts.Contacts
        });
      });
  };

  FreeData = () => {
    const filter = this.filter2();

    fetchMethod(campaignFreeContacts, filter)
      .then(res => res.json())
      .then(res => {
        this.setState({
          totalFreeCount: res.data.allContacts.totalCount
        });
      });
  };
  OpenData = () => {
    const filter = this.filter3();
    fetchMethod(campaignFreeContacts, filter)
      .then(res => res.json())
      .then(res => {
        this.setState({
          totalOpenCount: res.data.allContacts.totalCount
        });
      });
  };
  OpenUsedData = () => {
    const filter = this.filter4();
    fetchMethod(campaignFreeContacts, filter)
      .then(res => res.json())
      .then(res => {
        this.setState({
          totalOpenUsedCount: res.data.allContacts.totalCount
        });
      });
  };
  Profile = () => {
    fetchMethod(Profileid(this.props.campaignId))
      .then(res => res.json())
      .then(res => {
        this.setState({
          profileid:
            res.data.Campaigns.customercredentialsIbfk1rel
              .Customerlinkedinprofiles[0].id,
          hubspottoken:
            res.data.Campaigns.customercredentialsIbfk1rel
              .Customerlinkedinprofiles[0].hubspottoken,
          salesforcetoken:
            res.data.Campaigns.customercredentialsIbfk1rel
              .Customerlinkedinprofiles[0].salesforcetoken
        });
      })
      .catch(e => console.log(e));
  };

  emptySelectedArray = () => {
    this.setState({ selectedArray: [], selectAll: false, selected: {} });
  };

  handleDateChange = date => {
    this.setState({
      selectedDate: date
    });
  };

  SetLimit = limit => {
    this.setState({
      limit
    });
  };

  SetOffset = offset => {
    this.setState({ offset });
  };

  setContactsListData = response => {
    let data = response.data.allContacts.Contacts;

    this.setState(
      {
        campaignContacts: data,
        totalCount: response.data.allContacts.totalCount

      },
      () => this.fetchSequence(this.state.campaignContacts)
    );
  };

  onSearchClick = () => {
    if (this.state.searchFlag === true) {
      this.setState({ clickToSearch: true }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData();
        this.FreeData();
        this.OpenData();
        this.OpenUsedData();
      });
    } else {
      this.setState({ clickToSearch: false }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData();
        this.FreeData();
        this.OpenData();
        this.OpenUsedData();
      });
    }
  };

  debounce = (debounceTimer, func, delay) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(func, delay);
    return debounceTimer;
  };
  debounceTimer = null;
  handleSearchChange = event => {
    this.setState({
      search: event.target.value,
      searchFlag: true,
      isSearching: true
    });
    this.debounceTimer = this.debounce(
      this.debounceTimer,
      () => {
        this.onSearchClick();
        this.setState({ isSearching: false });
      },
      200
    );
  };

  onTableRowClick = rowInfo => {
    this.setState({ Row: rowInfo.original.id });
  };

  fetchContactDrawerDetails = (side, open, row) => event => {
    this.setState({ getData: [] });
    fetchMethod(contacts(row.id))
      .then(res => res.json())
      .then(res => {
        res.data.allContacts !== undefined
          ? this.setState({
            ContactDetailsWorkflow:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].Contactworkflowhistoryfk
                  .Contactworkflowhistories
                : "",
            ContactDetailsMessages:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].Contactmessagesfk
                  .Contactmessages
                : "",
            getData:
              res.data.allContacts !== undefined &&
                res.data.allContacts !== null
                ? res.data.allContacts.Contacts[0]
                : "",
            getCampaignId:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].campaignid
                : "",
            getCampaignId2:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].campaignid
                : "",

            getCustomer:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null &&
                res.data.allContacts.Contacts[0].Campaigns.Campaigns.length > 0
                ? res.data.allContacts.Contacts[0].Campaigns.Campaigns[0]
                  .Customers.Customers[0]
                : "",
            contactStatus:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].contactstatus
                : "",
            campaignStatus:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].campaignstatus
                : "",
            contactId:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].id
                : ""
          })
          : this.setState({ loading: true });
      })
      .catch(e => console.log(e));
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ ...this.state, [side]: open });
  };

  closeDetails = () => {
    this.setState({
      openDetails: false,
      getCampaignId: [],
      getCustomer: [],
      getData: [],
      contactStatus: null,
      campaignStatus: null
    });
  };

  clearFilters = () => {
    this.setState(
      {
        search: "",
        searchFlag: false,
        clickToSearch: false,
        limit: 50,
        offset: 50
      },
      () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData();
        this.FreeData();
        this.OpenData();
        this.OpenUsedData();
      }
    );
  };

  fetchRefresh = response => {
    this.fetchMessage(response);
  };
  fetchMessage = response => {
    fetchMethod(contacts(response))
      .then(res => res.json())
      .then(res => {
        res.data.allContacts !== undefined
          ? this.setState({
            ContactDetailsMessages:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].Contactmessagesfk
                  .Contactmessages
                : ""
          })
          : this.setState({ loading: true });
      })
      .catch(e => console.log(e));
  };
  onSearchKeyDown = event => {
    return event.key === "Enter" ? this.onSearchClick() : "";
  };

  formatDate = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }

    return;
  };
  fetchRefresh1 = response => {
    this.fetchName(response);
  };
  fetchName = response => {
    fetchMethod(contacts(response))
      .then(res => res.json())
      .then(res => {
        res.data.allContacts !== undefined
          ? this.setState({
            getData:
              res.data.allContacts !== undefined &&
                res.data.allContacts !== null
                ? res.data.allContacts.Contacts[0]
                : ""
          })
          : this.setState({ loading: true });
      })
      .catch(e => console.log(e));
  };

  gettingAllDataFromQuery = () => {
    const filter = this.filter();
    fetchMethod(campaignContactsTabSelectList, filter)
      .then(response => {
        return response.json();
      })
      .then(responseAsJson => {
        let allselectedIds = [];
        responseAsJson.data.allContacts.Contacts.map(i => {
          allselectedIds.push({ id: i.id });
        });
        this.setState(
          {
            campaignContactAllSelectedList: allselectedIds
          },
          () => {
            let selectedArr = [];
            let consolidateArray = [];
            this.state.campaignContactAllSelectedList.map(item => {
              consolidateArray[item.id] = true;
              selectedArr.push({ id: item.id });
            });
            this.setState({
              selectAll: true,
              selected: consolidateArray,
              selectedArray: selectedArr
            });
          }
        );
      })
      .catch(e => {
        console.log(e);
        this.setState({ loading: true });
      });
  };

  onRowSelected = sarray => {
    if (sarray.length === this.state.totalCount) {
      this.setState({ selectAll: true });
    } else {
      this.setState({ selectAll: false });
    }
  };

  toggleRowNew = (id, rowInfo) => {
    const newSelected = Object.assign({}, this.state.selected);
    newSelected[id] = !this.state.selected[id];
    this.setState({
      selected: newSelected
    });
    const { selectedArray } = this.state;
    let arr = selectedArray.filter(val => val.id !== id);
    if (!arr.length) {
      this.setState(
        {
          selectedArray: []
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    }
    if (arr.length === selectedArray.length) {
      this.setState(
        {
          selectedArray: [...selectedArray, rowInfo]
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    } else {
      this.setState(
        {
          selectedArray: arr
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    }
  };

  toggleSelectAllRow = isChecked => {
    if (isChecked) {
      this.gettingAllDataFromQuery();
    } else {
      this.setState({
        selectAll: false,
        selectedArray: [],
        selected: {}
      });
    }
  };

  NameFilter = () => {
    this.setState({ columnFilter: "name asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  NameFilter1 = () => {
    this.setState({ columnFilter: "name desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  CompanyFilter = () => {
    this.setState({ columnFilter: "organization asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  CompanyFilter1 = () => {
    this.setState(
      { columnFilter: "organization desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  PositionFilter = () => {
    this.setState({ columnFilter: "designation asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  PositionFilter1 = () => {
    this.setState(
      { columnFilter: "designation desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  LocationFilter = () => {
    this.setState({ columnFilter: "location asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  LocationFilter1 = () => {
    this.setState({ columnFilter: "location desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  connectedonFilter = () => {
    this.setState({ columnFilter: "connectedon asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  connectedonFilter1 = () => {
    this.setState(
      { columnFilter: "connectedon desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  InvitationsentFilter = () => {
    this.setState(
      { columnFilter: "invitationsent asc", shortfilter: true },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  InvitationsentFilter1 = () => {
    this.setState(
      { columnFilter: "invitationsent desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  currentstatusFilter = () => {
    this.setState(
      { columnFilter: "currentstatus asc", shortfilter: true },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  currentstatusFilter1 = () => {
    this.setState(
      { columnFilter: "currentstatus desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  filter = () => {
    const search = this.state.clickToSearch ? this.state.search : "";
    const like = `%${search}%`; //"%" + `${search}` + "%";
    const filter = {
      where: {
        campaignid: this.props.campaignId,
        active: 1,
        leads: {
          nlike: "%1%",
          options: "i"
        },
        engaged: {
          nlike: "%1%",
          options: "i"
        },
        noop: 0,
        //  open:0,
        order: this.state.columnFilter,

        and: [
          {
            or: [
              { organization: { like: like, options: "i" } },
              { name: { like: like, options: "i" } },
              { designation: { like: like, options: "i" } },
              { location: { like: like, options: "i" } }
            ]
          }
        ]
      }
    };
    return filter;
  };
  filter2 = () => {
    const search = this.state.clickToSearch ? this.state.search : "";
    const like = `%${search}%`;  // "%" + `${search}` + "%";   


    const filter = {
      where: {
        campaignid: this.props.campaignId,

        active: 1,
        engaged: 0,
        noop: 0,
        leads: 0,
        campaignstatus: null,
        leads: {
          nlike: "%1%",
          options: "i"
        },
        engaged: {
          nlike: "%1%",
          options: "i"
        },
        noop: 0,
        order: this.state.columnFilter,

        and: [
          {
            or: [
              { organization: { like: like, options: "i" } },
              { name: { like: like, options: "i" } },
              { designation: { like: like, options: "i" } },
              { location: { like: like, options: "i" } }
            ]
          }
        ]
      }
    };
    return filter;
  };
  filter3 = () => {
    const search = this.state.clickToSearch ? this.state.search : "";
    const like = `%${search}%`;  // "%" + `${search}` + "%";   


    const filter = {
      where: {
        campaignid: this.props.campaignId,

        active: 1,
        engaged: 0,
        noop: 0,
        leads: 0,
        open: 1,
        leads: {
          nlike: "%1%",
          options: "i"
        },
        engaged: {
          nlike: "%1%",
          options: "i"
        },
        noop: 0,
        order: this.state.columnFilter,

        and: [
          {
            or: [
              { organization: { like: like, options: "i" } },
              { name: { like: like, options: "i" } },
              { designation: { like: like, options: "i" } },
              { location: { like: like, options: "i" } }
            ]
          }
        ]
      }
    };
    return filter;
  };
  filter4 = () => {
    const search = this.state.clickToSearch ? this.state.search : "";
    const like = `%${search}%`;  // "%" + `${search}` + "%";   


    const filter = {
      where: {
        campaignid: this.props.campaignId,

        active: 1,
        engaged: 0,
        noop: 0,
        leads: 0,
        open: 1,
        currentstatus: {
          neq: ""
        },
        // campaignstatus: {
        //   neq: null
        // },
        leads: {
          nlike: "%1%",
          options: "i"
        },
        engaged: {
          nlike: "%1%",
          options: "i"
        },
        noop: 0,
        order: this.state.columnFilter,

        and: [
          {
            or: [
              { organization: { like: like, options: "i" } },
              { name: { like: like, options: "i" } },
              { designation: { like: like, options: "i" } },
              { location: { like: like, options: "i" } }
            ]
          }
        ]
      }
    };
    return filter;
  };
  fetchSequence = async responsee => {
    let index = 0;
    responsee.map(async response => {
      if (
        response !== undefined &&
        response.currentStage !== undefined &&
        response.currentStage.Contactworkflowhistories !== undefined
      ) {
        let l = response.currentStage.Contactworkflowhistories.length - 1;
        let sequence = response.currentStage.Contactworkflowhistories[l];
        if (
          sequence &&
          sequence.contactworkflowhistoryIbfk2rel &&
          sequence.contactworkflowhistoryIbfk2rel.Campaignsteps[0] &&
          sequence.contactworkflowhistoryIbfk2rel &&
          sequence.contactworkflowhistoryIbfk2rel.Campaignsteps[0]
        ) {
          const plannedDateFilter = {
            where: {
              campaignid:
                sequence.contactworkflowhistoryIbfk2rel.Campaignsteps[0]
                  .campaignid,
              active: 1,
              sequence:
                sequence.contactworkflowhistoryIbfk2rel.Campaignsteps[0]
                  .sequence + 1
            }
          };

          response.currentStage.Contactworkflowhistories[
            l
          ].nextStep = undefined;
          await fetchMethod(plannedDate, plannedDateFilter)
            .then(res => res.json())
            .then(res => {
              if (
                res &&
                res.data &&
                res.data.allCampaignsteps &&
                res.data.allCampaignsteps.Campaignsteps.length > 0 &&
                res.data.allCampaignsteps.Campaignsteps[0]
              ) {
                let daysDelay =
                  res.data.allCampaignsteps.Campaignsteps[0].daysdelay;
                let NextStepName =
                  res.data.allCampaignsteps.Campaignsteps[0].stepname;
                if (
                  NextStepName === "SEND_THANKS_MESSAGE" &&
                  response.connectedon
                ) {
                  var Connectedon = "";
                  if (
                    response.thanksmsgdate === "" ||
                    response.thanksmsgdate == null
                  ) {
                    Connectedon = response.connectedon.split("/");
                  } else {
                    Connectedon = response.thanksmsgdate.split("/");
                  }

                  Connectedon =
                    Connectedon[2] +
                    "/" +
                    Connectedon[1] +
                    "/" +
                    Connectedon[0];
                  let date = new Date(Connectedon);
                  let someDate = new Date(date);

                  let addDate = 0;
                  if (
                    response.thanksmsgdate === "" ||
                    response.thanksmsgdate == null
                  ) {
                    addDate = daysDelay;
                  } else {
                    addDate = 0;
                  }

                  let dd1 = someDate.setDate(someDate.getDate() + addDate);

                  let oldDate = new Date(dd1);

                  let todayDate = new Date();

                  let diffTime = todayDate - oldDate;

                  let diffDays = diffTime / (1000 * 60 * 60 * 24);

                  if (diffDays >= 0) {
                    let Planndate = new Date(todayDate);

                    let dd = Planndate.getDate(dd1);
                    let mm = Planndate.getMonth() + 1;
                    let yyyy = Planndate.getFullYear();
                    if (dd < 10) {
                      dd = "0" + dd;
                    }
                    if (mm < 10) {
                      mm = "0" + mm;
                    }

                    Planndate = `${dd}/${mm}/${yyyy}`;

                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      "Send Thanks Message " + Planndate;
                  } else if (diffDays < 0) {
                    let Planndate = new Date(oldDate);

                    let dd = Planndate.getDate(dd1);
                    let mm = Planndate.getMonth() + 1;
                    let yyyy = Planndate.getFullYear();
                    if (dd < 10) {
                      dd = "0" + dd;
                    }
                    if (mm < 10) {
                      mm = "0" + mm;
                    }

                    Planndate = `${dd}/${mm}/${yyyy}`;
                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      "Send Thanks Message " + Planndate;
                  } else {
                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      "Send Thanks Message " + date;
                  }
                } else if (NextStepName !== "SEND_THANKS_MESSAGE") {
                  var current_date = "";
                  var addDay = 0;
                  if (sequence.nextstep == null || sequence.nextstep === "") {
                    current_date = sequence.executedon;
                    addDay = daysDelay;
                  } else {
                    current_date = sequence.nextstep;
                    addDay = 0;
                  }

                  var someDate = new Date(current_date);

                  current_date = someDate.setDate(someDate.getDate() + addDay);
                  let oldDate = new Date(current_date).getTime();
                  let todayDate = new Date().getTime();

                  let difference = todayDate - oldDate;
                  let diffDays = difference / (1000 * 3600 * 24);

                  if (diffDays >= 0) {
                    let date = moment(todayDate).toDate();
                    let current_date1 = new Date(date);
                    let utc =
                      current_date1.getTime() +
                      current_date1.getTimezoneOffset() * 60000;
                    let offset_time = new Date(utc + 3600000 * 5.5);
                    let planDate = moment(offset_time).format("DD/MM/YYYY");
                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      NextStepName === "SEND_INVITE"
                        ? "Send Invite"
                        : NextStepName === "FOLLOW"
                          ? "Follow"
                          : NextStepName === "VISIT"
                            ? "Visit"
                            : "Send Message" + " " + planDate;
                  } else if (diffDays < 0) {
                    let date = moment(oldDate).toDate();

                    let current_date1 = new Date(date);
                    let utc =
                      current_date1.getTime() +
                      current_date1.getTimezoneOffset() * 60000;
                    let offset_time = new Date(utc + 3600000 * 5.5);
                    let planDate = moment(offset_time).format("DD/MM/YYYY");

                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      NextStepName === "SEND_INVITE"
                        ? "Send Invite"
                        : NextStepName === "FOLLOW"
                          ? "Follow"
                          : NextStepName === "VISIT"
                            ? "Visit"
                            : "Send Message" + " " + planDate;
                  } else {
                    let date = moment(current_date)
                      .add(daysDelay, "days")
                      .toDate();
                    let current_date1 = new Date(date);
                    var utc =
                      current_date1.getTime() +
                      current_date1.getTimezoneOffset() * 60000;
                    var offset_time = new Date(utc + 3600000 * 5.5);
                    var date1 = moment(offset_time).format("DD/MM/YYYY");

                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      NextStepName === "SEND_INVITE"
                        ? "Send Invite"
                        : NextStepName === "FOLLOW"
                          ? "Follow"
                          : NextStepName === "VISIT"
                            ? "Visit"
                            : "Send Message" + " " + date1;
                  }
                }
              }
            })
            .catch(e => console.log(e));
        }
      }
      index++;
      if (index === responsee.length && this.state.totalCount !== 0) {
        this.setState({ campaignContacts: responsee });
      }
    });
  };

  showEngagedToPopup = row => e => {
    this.setState({
      selectedEngagedRow: {
        ...row,

        anchorEl: e.currentTarget
      },

      clientY: e.clientY,
      clientX: e.clientX
    });
    this.ExportData();
    this.FreeData();
    this.OpenData();
    this.OpenUsedData();
  };

  onCloseEngagedPopup = () => {
    this.setState({ selectedEngagedRow: null });
  };

  convertArrayToObject = (selectedArrayIds, type) => {
    let SelectedIds = [];
    if (type === "removeContact") {
      selectedArrayIds.map(item => {
        return SelectedIds.push({ id: item, createdBy: MoveToContact.createdBy, action: "CONVERT_TO_REMOVE", active: 0, campaignStatus: "PAUSED" });
      });
      return SelectedIds;
    }
    else {
      selectedArrayIds.map(item => {
        return SelectedIds.push({ id: item, createdBy: MoveToContact.createdBy, action: "CONVERT_TO_ENGAGED", engaged: 1, campaignStatus: "PAUSED" });
      });
      return SelectedIds;
    }
  };

  OnRemoveToContactClick = async (selectedArray, type) => {
    this.setState({ disabled: true });
    let selectedArrayIds = [];
    selectedArray.map(a => {
      return selectedArrayIds.push(a.id);
    });
    let SelectedIds = this.convertArrayToObject(selectedArrayIds, type);
    if (selectedArray.length > 0) {
      SelectedIds = JSON.stringify(SelectedIds);
      await fetch(
        `${RemoveToContactUpdate.url}` +
        `${SelectedIds}` +
        `&access_token=${RemoveToContactUpdate.token}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        }
      )
        .then(res => res.json())
        .then(res => {
          if (res.status === 401) {
            localStorage.clear();
            window.location = "/";
          } else {
            this.setState(
              { selectedArray: [], selectAll: false, selected: {} },
              () => {
                this.fetchTempList();
                this.child.current.searchFetch(
                  this.state.limit,
                  this.state.offset
                );
                swal("Successfully Removed", { icon: "success" });
                this.setState({ disabled: false });
              }
            );
          }
        })
        .catch(e => {
          swal({ title: "Please try again after some time", icon: "warning" });
          this.setState({ disabled: false });
        });
    } else {
      swal("Please select contact", { icon: "warning" });
      this.setState({ disabled: false });
    }
  };

  OnConvertEngaged = async (selectedArray, type) => {
    this.setState({ disabled: true });
    let selectedArrayIds = [];
    selectedArray.map(a => {
      return selectedArrayIds.push(a.id);
    });
    let SelectedIds = this.convertArrayToObject(selectedArrayIds, type);
    if (selectedArray.length > 0) {
      SelectedIds = JSON.stringify(SelectedIds);
      await fetch(
        // `${RemoveToContact.url}` +
        //   `${SelectedIds}` +
        //   `&access_token=${RemoveToContact.token}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        }
      )
        .then(res => res.json())
        .then(res => {
          if (res.status === 401) {
            localStorage.clear();
            window.location = "/";
          } else {
            this.setState(
              { selectedArray: [], selectAll: false, selected: {} },
              () => {
                this.fetchTempList();
                this.child.current.searchFetch(
                  this.state.limit,
                  this.state.offset
                );
                swal("Successfully Removed", { icon: "success" });
                this.setState({ disabled: false });
              }
            );
          }
        })
        .catch(e => {
          swal({ title: "Please try again after some time", icon: "warning" });
          this.setState({ disabled: false });
        });
    } else {
      swal("Please select contact", { icon: "warning" });
      this.setState({ disabled: false });
    }
  };

  render() {

    // var cc = this.state.Row;
    const campaignContacts = [...this.state.campaignContacts];

    const { selectedEngagedRow } = this.state;
    const campaignContactsExportData = [
      ...this.state.campaignContactsExportData
    ];
    var totalContactAll = this.state.totalCount;
    let moveToContactCount = this.state.selectedArray.length;

    const CampaignContactsListHeaders = [
      {
        Header: obj => {
          return (
            <Checkbox
              defaultChecked
              size="small"
              value="small"
              color="primary"
              style={{ fontWeight: "thick" }} //style="thick"
              inputProps={{ "aria-label": "checkbox with small size" }}
              checked={this.state.selectAll}
              onChange={e => {
                this.toggleSelectAllRow(e.target.checked);
              }}
            />
          );
        },
        Cell: rowInfo => {
          return (
            <Checkbox
              defaultChecked
              size="small"
              value="small"
              color="primary"
              style="thick"
              inputProps={{ "aria-label": "checkbox with small size" }}
              checked={this.state.selected[rowInfo.original.id] === true}
              onChange={() =>
                this.toggleRowNew(rowInfo.original.id, rowInfo.original)
              }
            />
          );
        }
      },
      {
        Header: "Image",
        accessor: "Image",
        width: 100
      },
      // {
      //   Header: "Gender",
      //   accessor: "gender"
      // },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.NameFilter
                  : this.NameFilter1
              }
            >
              Name
            </div>
          );
        },
        accessor: "Name",
        width: 150,
        Cell: row => (
          <div
            style={{ cursor: "pointer", color: "#2BADDD" }}
            onClick={this.fetchContactDrawerDetails(
              "openDetails",
              true,
              row.original
            )}
          >
            {row.original.name}
          </div>
        )
      },
    
      {
        Header: "Gender",
        accessor: "gender"
      },
      {
        Header: "First Name",
        accessor: "fname"
      },
      {
        Header: "Surname",
        accessor: "surname"
      },
      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.CompanyFilter
                  : this.CompanyFilter1
              }
            >
              Current Company
            </div>
          );
        },
        accessor: "organization",
        width: 150
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.PositionFilter
                  : this.PositionFilter1
              }
            >
              Current Position
            </div>
          );
        },
        accessor: "designation",
        width: 150,
      },
      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.LocationFilter
                  : this.LocationFilter1
              }
            >
              Location
            </div>
          );
        },
        accessor: "location",
        width: 150,
      },
      {
        Header: " Profile",
        accessor: "Open"
      },
      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.connectedonFilter
                  : this.connectedonFilter1
              }
            >
              Connected On
            </div>
          );
        },
        accessor: "Connectedon"
      },
      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.InvitationsentFilter
                  : this.InvitationsentFilter1
              }
            >
              Invitation Sent
            </div>
          );
        },
        accessor: "InvitationSent"
      },

      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.currentstatusFilter
                  : this.currentstatusFilter1
              }
            >
              Current Stage
            </div>
          );
        },
        accessor: "CurrentStage"
      },
      {
        Header: "Next Step",
        accessor: "Next_Step",
        width: 150
      },
      // {
      //   Header: "Last Response",
      //   accessor: "LR",

      // },

      {
        Header: " Status",
        accessor: "CampaignStatus"
      },
      {
        Header: "",
        Cell: row => {
          return (
            <div className="iconButton">
              {localStorage.getItem("role") !== "CUSTOMER" ? (
                <IconButton
                  aria-haspopup="true"
                  onClick={this.showEngagedToPopup(row)}
                >
                  <MoreVertIcon />
                </IconButton>
              ) : (
                ""
              )}
            </div>
          );
        }
      }
    ];

    campaignContacts.map(list => {
      if (
        list.lastresponse !== undefined &&
        list.lastresponse !== null &&
        list.lastresponse
      ) {
        list.LR = this.formatDate(list.lastresponse.split("T")[0]);
      }


      let image =
        list.profileimage !== undefined && list.profileimage !== null
          ? list.profileimage.substr(0, 5)
          : "";
      let imageSourceUrl = getContactImageUrl;
          if (list.id > 917500) {
          imageSourceUrl = getContactImageUrl2;
        }
      if (image === "https") {
        if (list.id > 917500) {
          imageSourceUrl = getContactImageUrl2;
        }
        list.Image = (
          <div
            style={{ cursor: "pointer" }}
            onClick={this.fetchContactDrawerDetails("openDetails", true, list)}
          >
            <img
              src={list.profileimage}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = imageSourceUrl.url + list.image;
              }}
              style={{ borderRadius: "50%", width: "30px" }}
            />
          </div>
        );
      } else {
        list.Image = (
          <div
            style={{ cursor: "pointer" }}
            onClick={this.fetchContactDrawerDetails("openDetails", true, list)}
          >
            <img
              src={imageSourceUrl.url + list.image}
              style={{ borderRadius: "50%", width: "30px" }}
            />
          </div>
        );
      }

      list.CampaignStatus =
        list.campaignstatus !== null && list.campaignstatus !== undefined
          ? list.campaignstatus === "COMPLETED"
            ? "Completed"
            : list.campaignstatus === "PAUSE"
              ? "Pause"
              : "Live"
          : "";


      // list.Open = (list.open === 0) ? "" : (list.open === 1) ? "Open" : undefined;

      if (
        list.open == undefined ||
        list.open == null ||
        list.open == ""
      ) {
        //   debugger;
        // list.Open = (
        //   <div className="onffSwitchmonitor2">

        //     <FiberManualRecordIcon
        //       checked={list.open === 0 ? true : false}

        //       name="checkedA"

        //     />
        //   </div>
        // );

      }
      else {
        list.Open = (
          <div className="onffSwitchmonitor4">
            <FiberManualRecordIcon
              checked={list.open === 1 ? true : false}
              name="checkedA"

            />
          </div>
        );
      }

      if (
        list.connectedon !== undefined &&
        list.connectedon !== null &&
        list.connectedon
      ) {
        list.Connectedon = this.formatDate(list.connectedon);
      }
      if (
        list.invitationsent !== undefined &&
        list.invitationsent !== null &&
        list.invitationsent
      ) {
        list.InvitationSent = this.formatDate(
          list.invitationsent.split("T")[0]
        );
      }

      if (
        list.currentstatus !== undefined &&
        list.currentstatus !== null &&
        list.currentstatus
      ) {
        list.CurrentStage = list.currentstatus;
      }

      if (
        list.currentstatus !== undefined &&
        list.currentstatus !== null &&
        list.currentstatus
      ) {
        if (
          list.invitesent === 0 &&
          (list.currentstatus === "Invite Sent" ||
            list.currentstatus === "Invite Not Sent")
        ) {
          list.CurrentStage = "Invite not Sent";
        } else {
          list.CurrentStage = list.currentstatus;
        }
      }

      if (list.connectedon !== "" && list.connectedon != null) {
        if (
          list.nextstepname !== undefined &&
          list.nextstepname !== null &&
          list.nextstepname
        ) {
          let oldDate = new Date(list.nextstepdate);
          if (list.nextstepdate === "" || list.nextstepdate == null) {
            oldDate = new Date(list.thanksmsgdate);
          }
          var nextDate1 = "";
          let todayDate = new Date();
          let diffTime = todayDate - oldDate;
          let diffDays = diffTime / (1000 * 60 * 60 * 24);
          if (diffDays >= 0) {
            let Planndate = new Date();
            let dd = Planndate.getDate();
            let mm = Planndate.getMonth() + 1;
            let yyyy = Planndate.getFullYear();
            if (dd < 10) {
              dd = "0" + dd;
            }
            if (mm < 10) {
              mm = "0" + mm;
            }
            nextDate1 = `${dd}/${mm}/${yyyy}`;
          } else {
            nextDate1 = list.nextstepdate;
          }
          list.Next_Step = list.nextstepname + " " + this.formatDate(nextDate1);
        }
      }
      if (
        list.open == 1
      ) {
        if (
          list.nextstepname !== undefined &&
          list.nextstepname !== null &&
          list.nextstepname
        ) {
          let oldDate = new Date(list.nextstepdate);
          if (list.nextstepdate === "" || list.nextstepdate == null) {
            oldDate = new Date(list.thanksmsgdate);
          }
          var nextDate1 = "";
          let todayDate = new Date();
          let diffTime = todayDate - oldDate;
          let diffDays = diffTime / (1000 * 60 * 60 * 24);
          if (diffDays >= 0) {
            let Planndate = new Date();
            let dd = Planndate.getDate();
            let mm = Planndate.getMonth() + 1;
            let yyyy = Planndate.getFullYear();
            if (dd < 10) {
              dd = "0" + dd;
            }
            if (mm < 10) {
              mm = "0" + mm;
            }
            nextDate1 = `${dd}/${mm}/${yyyy}`;
          } else {
            nextDate1 = list.nextstepdate;
          }
          list.Next_Step = list.nextstepname + " " + this.formatDate(nextDate1);
        }
      }

      if (
        list.nextstepname !== "Send Thanks Message" &&
        list.nextstepname !== "Send Message"
      ) {
        if (
          list.nextstepname !== undefined &&
          list.nextstepname !== null &&
          list.nextstepname
        ) {
          var shownextstepname = "";
          if (list.nextstepname === "Invite Sent") {
            shownextstepname = "Send Invite";
          } else {
            shownextstepname = list.nextstepname;
          }

          list.Next_Step = shownextstepname;
        }
      }

      return null;
    });

    campaignContactsExportData.map(list => {
      if (
        list.lastresponse !== undefined &&
        list.lastresponse !== null &&
        list.lastresponse
      ) {
        list.LR = list.lastresponse;
      }
      if (
        list.invitationsent !== undefined &&
        list.invitationsent !== null &&
        list.invitationsent
      ) {
        list.InvitationSent = list.invitationsent.split("T")[0];
      }
      if (
        list.currentstatus !== undefined &&
        list.currentstatus !== null &&
        list.currentstatus
      ) {
        list.CurrentStage = list.currentstatus;
      }
    });

    const filter = this.filter();

    return (
      <div className="CampaignContactsTab">
        <div className="CampaignContactsHeader">
          <div className="CampaignContactsLeftFilters">
            <Drawer
              anchor="right"
              open={this.state.openDetails}
              onClose={() => this.closeDetails()}
            >
              <ContactDetails
                onSearchClick={this.onSearchClick}
                refreshMessage1={this.fetchRefresh1}
                refreshMessage={this.fetchRefresh}
                Close={() => this.closeDetails()}
                details={this.state.getData}
                Campaignid={this.state.getCampaignId2}
                Customer={this.state.getCustomer}
                contactStatus={this.state.contactStatus}
                campaignStatus={this.state.campaignStatus}
                id={this.state.contactId}
                tableRerender={this.child.current}
                limit={this.state.limit}
                offset={this.state.offset}
                ContactDetailsWorkflow={this.state.ContactDetailsWorkflow}
                ContactDetailsMessages={this.state.ContactDetailsMessages}
                heading={"Contact Details"}
              />
            </Drawer>

            <div className="searchContact">
              <TextField
                id="outlined-search"
                label="Search"
                placeholder="Company/name/position/location"
                margin="normal"
                variant="outlined"
                value={this.state.search}
                onChange={this.handleSearchChange}
                onKeyDown={this.onSearchKeyDown}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <img
                      src={SearchIcon}
                      style={{ width: "15px", cursor: "pointer" }}
                      onClick={() => this.onSearchClick()}
                    />
                  )
                }}
              />
            </div>

            <div className="CampaignContactsButton">
              <Button className="button" onClick={this.clearFilters}>
                <span style={{ textTransform: "capitalize" }}> Reset All</span>

              </Button>
            </div>

            {selectedEngagedRow && (
              <ConvertTo
                refresh={() => this.ExportData()}
                refresh2={() => this.FreeData()}
                refresh3={() => this.OpenData()}
                refresh4={() => this.OpenUsedData()}
                target={selectedEngagedRow && selectedEngagedRow.anchorEl}
                contactStatus={selectedEngagedRow.original.contactstatus}
                campaignStatus={selectedEngagedRow.original.campaignstatus}
                id={selectedEngagedRow.original.id}
                clientY={this.state.clientY}
                clientX={this.state.clientX}
                tableRerender={this.child.current}
                onClose={this.onCloseEngagedPopup}
                limit={this.state.limit}
                offset={this.state.offset}
              />
            )}

            {/* <div className="freecontactRecords"
             
            >
                <p
                style={{
                  color: "#36454d",
                  fontSize: "15px"
                }}
              >                

                Open Contacts Used:{" "}
                 <span>{this.state.totalOpenUsedCount}</span>/<span>{this.state.totalOpenCount}</span>  
                {"   "}
                &nbsp;   Free Contacts:{" "}
                <span>{this.state.totalFreeCount}</span>/<span>{this.state.totalCount}</span>  

                 {/* <span>
                  {this.state.totalFreeCount}
                  {"   "}
                </span>
                &nbsp; {"   "}Total Records:{" "}
                <span>{this.state.totalCount}</span> */}

            {/* </p>
            </div>   */}

            <div className="freecontactRecords">
              <p
                style={{
                  color: "#36454d",
                  fontSize: "15px"
                }}
              >

                {this.state.openCampaign === 1 ? (
                  <>
                    Open Contacts Used:{" "}
                    <span>{this.state.totalOpenUsedCount}</span>/<span>{this.state.totalOpenCount}</span>
                    {"   "}
                    &nbsp;   Free Contacts:{" "}
                    <span>{this.state.totalFreeCount}</span>/<span>{this.state.totalCount}</span>
                    {"   "}
                    &nbsp; {"   "}Total Records:{" "}
                    <span>{this.state.totalCount + this.state.totalOpenCount}</span>
                  </>
                ) : (
                  <>
                    Free Contacts:{" "}
                    <span>
                      {this.state.totalFreeCount}
                      {"   "}
                    </span>
                    {"   "}
                    &nbsp; {"   "}Total Records:{" "}
                    <span>{this.state.totalCount}</span>
                  </>
                )}
              </p>
            </div>


            <div className="RightContext">
              <ExportTo
                fileData={campaignContactsExportData}
                ContactDetailsMessages={this.state.ContactDetailsMessages}
                SalesHubdata={this.state.selectedArray}
                Profile={this.state.profileid}
                selectedArray={this.emptySelectedArray}
                SalesforceToken={this.state.salesforcetoken}
                HubspotToken={this.state.hubspottoken}
              />
            </div>

          </div>

        </div>
        {/* 
        <div className="CampaignTempListRightFilters">
        <span>
            {moveToContactCount === 0 || moveToContactCount === undefined
              ? "No out of " + `${totalContactAll}` + " contacts are selected"
              : moveToContactCount === 1
              ? `${moveToContactCount}` +
                " out of " +
                `${totalContactAll}` +
                " contacts are selected"
              : `${moveToContactCount}` +
                " out of " +
                `${totalContactAll}` +
                " contacts are selected"}
          </span>

          <Button
            onClick={() => this.OnConvertEngaged(this.state.selectedArray,"convertEngaged")}
            disabled={this.state.disabled}
          >
            <span style={{ color: "#3F6BE0", fontSize: "13px" }}>
              Convert Engaged
            </span>
          </Button>

          <Button
            onClick={() =>
              this.OnRemoveToContactClick(this.state.selectedArray,"removeContact",)
            }
            disabled={this.state.disabled}
          >
            <span style={{ color: "#FF2C00", fontSize: "13px" }}>
              Remove selected
            </span>
          </Button>

       
        </div> */}

        <ReactTableComponent
          ref={this.child}
          listData={this.state.campaignContacts}
          listConfig={CampaignContactsListHeaders}
          setData={this.setContactsListData}
          query={campaignContactsTabList}
          totalCount={this.state.totalCount}
          setLimit={this.SetLimit}
          setOffset={this.SetOffset}
          filter={filter}
          clickToSearch={this.state.clickToSearch}
          onRowClick={this.onTableRowClick}
        />
      </div>
    );
  }
}
export default CampaignContactsTab;

